import React from "react";
import { Chip } from '@mui/material';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from '@mui/icons-material/Close';
import i18next from "i18next";
import {theme} from '../../style/globalStyle';

const StatusChip = ({status, label}) => {
    const isActive = status === "active";

    return (
        <Chip
            className={isActive ? "" : "greyChip"}
            icon={isActive
              ? <CheckIcon style={{backgroundColor: theme.palette.primary.primary50 , borderRadius: "50%", color: theme.palette.primary.primary500}}/>
              : <CloseIcon style={{backgroundColor: theme.palette.grey.grey200, borderRadius: "50%", color: theme.palette.grey.main}}/>
            }
            size="small"
            label={i18next.t(label + "."+ status)}
            sx={{
                borderColor: isActive ? theme.palette.primary.primary500 : theme.palette.grey.main,
                color: isActive ? theme.palette.primary.primary500 : theme.palette.grey.main,
            }}
            variant="outlined"
        />
    )
}
export default StatusChip;